import { create } from "zustand";

// Define modal types
export enum ModalType {
  MANAGEMENT_IDENTIFIED = "MANAGEMENT_IDENTIFIED",
  MANAGEMENT_VERIFIED = "MANAGEMENT_VERIFIED",
  LOGIN = "LOGIN",
  // Add more as needed
}

interface Modal {
  type: ModalType;
  props: any;
}

interface ModalStore {
  modals: Modal[];
  openModal: (type: ModalType, props?: any) => void;
  closeModal: (type?: ModalType) => void;
  closeAllModals: () => void;
}

export const useModalStore = create<ModalStore>((set, get) => ({
  modals: [],

  openModal: (type, props = {}) => {
    const { modals } = get();
    // Prevent duplicate modals
    if (modals.some((modal) => modal.type === type)) return;

    set({ modals: [...modals, { type, props }] });
  },

  closeModal: (type) => {
    const { modals } = get();
    if (type) {
      // Close specific modal type
      set({ modals: modals.filter((modal) => modal.type !== type) });
    } else {
      // Close last modal (pop)
      set({ modals: modals.slice(0, -1) });
    }
  },

  closeAllModals: () => set({ modals: [] }),
}));
